import { createEntityAdapter } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Prompt, PromptsState } from './models';
import { promptsActions } from './prompts.actions';

export const promptsAdapter = createEntityAdapter<Prompt>();

export const promptsInitialState: PromptsState = promptsAdapter.getInitialState({
  filteredPrompts: [],
  loaded: false,
  allPromptsLoaded: false,
});

export const promptsReducer = createReducer(
  promptsInitialState,

  on(promptsActions.loadPromptsSuccess, (state, { prompts }) => promptsAdapter.setAll(prompts, state)),

  on(promptsActions.deletePromptSuccess, (state, { promptId }) => ({
    ...promptsAdapter.removeOne(promptId, state),
    filteredPrompts: state.filteredPrompts.filter(prompt => prompt.id !== promptId),
  })),

  on(promptsActions.clearAllPrompts, () => promptsInitialState),

  on(promptsActions.loadFilteredPromptsSuccess, (state, { prompts }) => ({
    ...state,
    filteredPrompts: prompts,
    loaded: true,
  })),

  on(promptsActions.loadPrompts, state => ({ ...state, allPromptsLoaded: false })),

  on(promptsActions.loadPromptsSuccess, promptsActions.loadPromptsFailure, state => ({
    ...state,
    allPromptsLoaded: true,
  })),
);

export const promptsFeature = createFeature({
  name: 'prompts',
  reducer: promptsReducer,
});
